import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FixedServiceInvoiceList from "./FixedServiceInvoiceList";
import {getValetContractInvoice} from "services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetContractInvoice
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FixedServiceInvoiceList);
